import { useLocation, Link } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex flex-col items-center justify-center min-h-screen bg-background-50 text-center px-4">
      <div className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-background-100/40 select-none pointer-events-none z-0">
        404
      </div>
      <div className="relative z-10">
        <h1 className="font-heading text-xl md:text-2xl font-semibold text-foreground-900 mt-6">
          This page has not been generated
        </h1>
        <p className="mt-2 text-sm text-foreground-500">{location.pathname}</p>
        <p className="mt-4 text-sm md:text-base text-foreground-400">
          Tell me more about this page, so I can generate it
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 mt-6 px-5 py-2.5 bg-primary-500 text-background-50 text-sm font-semibold rounded-lg hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
        >
          <i className="ri-home-4-line text-sm"></i>
          Back to Homepage
        </Link>
      </div>
    </div>
  );
}